// Ready Function
$(document).ready(function() {
  
    // Product Description
    jQuery('.description-btn').on('click', function(){
        jQuery('.product-description').toggleClass('more');
    });

    jQuery('.description-btn.read-less').on('click', function(e){
        e.preventDefault();
        var href = $(this).attr('href');
        $('html, body').animate({ 
            scrollTop:$(href).offset().top
        },'slow');
    });
});
// End Ready Function


var swiper = new Swiper(".pcSwiper", {
  spaceBetween: 25,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
        slidesPerView: 1,
        spaceBetweenSlides: 10
    },
    768: {
        slidesPerView: 2,
        spaceBetweenSlides: 20
    },
    999: {
        slidesPerView: 3,
        spaceBetweenSlides: 25
    }
  }
  
});